import _ from 'lodash'
import constants from 'scoreboard/components/constants'
import enums from 'scoreboard/components/enums'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import calendars from 'scoreboard/components/calendars'
import { shortenedAndUnshortened } from 'scoreboard/components/format-value'
import groupType from 'scoreboard/admin/principals/groups/group-type'
import principalItemsTemplate from '../common/principal-items.hbs'
import highlightedNameValueListTemplate from '../common/highlighted-name-value-list.hbs'

function principalList(principals) {
	groupType.groupTypeLabelAssignTo(principals)
	return {html: principalItemsTemplate({value: principals})}
}

function mvtString(mvts) {
	let value = _.map(mvts, mvt => ({
		'name': mvt.label,
		'value': i18n.get(enums.missingValueTreatment[mvt.missingValueTreatment])
	}))
	let html = highlightedNameValueListTemplate({value})
	return { html }
}

/**
 * Hash of column formatter keyed by their column values.  The values of each key are functions that take some
 * data and formats it to output either a text string or an object with an html property containing html representing
 * the value for that particular column
 */
const columnFormatters = {
	'calendar-id': val => val ? calendars.calendarsById[val].label : '',
	'scoring-type-id': val => val ? i18n.get(config.scoringType(val).labelKey) : '',
	'item-type': val => i18n.get(enums.scorecardItemType[val]),
	'data-type': val => i18n.get(enums.dataType[val]),
	'update-type': val => i18n.get(enums.updateType[val]),
	'aggregation-type': val => i18n.get(enums.aggregationType[val]),
	'missing-value-treatments': val => mvtString(val),
	'owners': val => principalList(val),
	'updaters': val => principalList(val),
	'weight': (val, column) => formattedNumericValue({value: val}, {dataType: 'percent'}, column),
	'equations': val => _.join(val, ', '),
	'tags': val => _.join(val, ', ')
}

/**
 * Hash translating columns json text value to their camelCased property
 * equivalent. Only needed when _.camelCase won't produce an accurate result.
 */
const valueToPropertyName = {
	'item-type': 'type',
	'variance-goal': 'variance',
	'percent-variance-goal': 'variancePercent',
	'percent-goal': 'towardGoalPercent',
	'ytd': 'actual',
	'weight': 'weighting'
}

const scoredMap = _.memoize(() => _.keyBy(constants.scorecardScoredColumns))

function formattedNumericValue(value, datum, columnAttributes) {
	if (_.isNil(value) || !datum) return ''
	let val = shortenedAndUnshortened(_.defaults({value}, datum, columnAttributes))
	return columnAttributes.abbreviated ? val.shortened : val.unshortened
}

function isColumnScored(columnType) {
	return !_.isNil(scoredMap()[columnType])
}

export { columnFormatters }
export { isColumnScored }
export { formattedNumericValue }
export { valueToPropertyName }